import { Divider } from "antd";
import React from "react";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Navbar from "../global-components/navbar";
import Footer_v1 from "../global-components/footer";
import BlogContact from "../../utils/blogContact";
import PageHeaderDeveloper from "./developerHeader";

import PropertyDetailsList from "../../JsonData/property-details.json"
import { slugify } from "../../utils/slugify";
import SimilarDeveloper from "./developerSimilar";
import DeveloperDetails from "./developerDetails";


const DeveloperMain = () => {
    const { developerSlug } = useParams();
    const [propertyData, setPropertyData] = useState(null);

    useEffect(() => {
        // const propertyId = Number(id);
        const foundProperty = PropertyDetailsList.PropertyDetailsList.find(
            (prop) => slugify(prop.DeveloperName) === developerSlug
        );

        if (foundProperty) {
            if (!foundProperty.images || foundProperty.imagee === 0) {
                foundProperty.images = [{ src: '/assets/img/no-image.jpg' }];
            }

            setPropertyData(foundProperty);

            console.log(propertyData?.metaTitle, "metetemetemete");
        }
    }, [developerSlug]);

    console.log(propertyData, "090909-09-9");
    
    return (
        <div>
            <Navbar />
            <PageHeaderDeveloper headertitle="Developers" />
            <DeveloperDetails  developername={propertyData?.DeveloperName}  />
            <SimilarDeveloper
                DeveloperName={propertyData?.DeveloperName}
            //  building_type={propertyData?.building_type}
            // propertyTypeList={propertyData?.propertyType?.map(p => p.type)} 

            />
            <BlogContact />
            <Footer_v1 />
        </div>
    );
};
export default DeveloperMain

